import { useAuth } from "../../utils/AuthContext";
import MyPatientsTable from "../MyPatientsTable";
import PageHeading from "../PageHeading";


const MyPatients = () => {
    const { user } = useAuth();
    const breadcrumbs = [
            { label: "Dashboard", url: "/dashboard" },
            { label: "My Practice"},
            { label: "All Patients" },
      ];
    return (
        <div>
            <PageHeading title="All Patients" breadcrumbs={breadcrumbs} />
            <MyPatientsTable user={user} />
        </div>
    );
};

export default MyPatients;